module.exports = __webpack_public_path__ + "img/fr-bre.8fef8dfe.svg";